import _translations from './translations.json';
const translations = _translations as {[key: string]: string};

const discriminatorRe = /^\[[^\]]*\](.*)/;

export function translate(language: string, input: string) {
  if (language.startsWith('nl') && translations[input]) {
    return translations[input];
  }

  if (input.startsWith('[')) {
    const reResult = discriminatorRe.exec(input);
    if (reResult) {
      input = reResult[1];
    }
  }
  return input;
}

export default {translate};
